import React from 'react';
import { getWhiteLabelLoaderComponent } from 'utils/whiteLabelConfig';

interface TheraLoaderProps {
  size?: number;
  color?: string;
}

const TheraLoaderSvg: React.FC = () => (
  <svg width="100%" height="100%" viewBox="0 0 230 186" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M219.926 0H10.0925C1.70816 0 -3.00692 9.64433 2.14255 16.261L31.5428 54.0378C33.4514 56.4903 36.3851 57.9245 39.4927 57.9245H81.411C86.9746 57.9245 91.4848 62.4347 91.4848 67.9984V130.884C91.4848 132.886 92.1864 134.824 93.4675 136.363L131.342 181.846C137.373 189.088 149.158 184.823 149.158 175.4V67.9984C149.158 62.4347 153.668 57.9245 159.231 57.9245H219.926C225.49 57.9245 230 53.4143 230 47.8507V10.0738C230 4.51021 225.49 0 219.926 0Z"
      fill="url(#paint0_linear_190_4)"
      className="svg-elem-1"
    />
    <defs>
      <linearGradient
        id="paint0_linear_190_4"
        x1="111.95"
        y1="-1.00546e-06"
        x2="46.0924"
        y2="186.564"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0E54A1" />
        <stop offset="1" stopColor="#030303" />
      </linearGradient>
    </defs>
  </svg>
);

const TheraLoader: React.FC<TheraLoaderProps> = ({ size = 70, color = '#CECECE' }) => {
  const WhiteLabelLoaderComponent = getWhiteLabelLoaderComponent();

  return (
    <div className="thera-loader" style={{ '--size': `${size}px`, '--color': color } as React.CSSProperties}>
      {WhiteLabelLoaderComponent ? <WhiteLabelLoaderComponent /> : <TheraLoaderSvg />}
    </div>
  );
};

export default TheraLoader;
